export default __webpack_public_path__ + "static/media/single-round-tree.ee6fa0a7.png";